// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-comments,.list-comments ul{padding-left:0;list-style:none}.list-comments .comment{padding:1.5rem}.list-comments>li{margin-top:1.5rem;background-color:#fff;box-shadow:0 .125rem .25rem rgba(0,0,0,.075)}.list-comments>li>*+*{border-top:1px solid #dee2e6}.list-comments>li:last-child{display:none}.loading .list-comments>li:last-child{display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
